import { render, staticRenderFns } from "./WorkIconNavSickNotes.vue?vue&type=template&id=f35a65be"
import script from "./WorkIconNavSickNotes.vue?vue&type=script&lang=js"
export * from "./WorkIconNavSickNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports